<template>
  <div id="app">
    <div v-wechat-title="$route.meta.title"></div>
    <keep-alive>
      <router-view v-if="$route.meta.keepalive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepalive"></router-view>
  </div>
</template>

<script>
import theme from "@/utils/theme";
export default {
  name: "App",
  data() {
    return {
      themeLoading: false,
    };
  },
  created() {
    // this.initTheme();
  },
  methods: {
    async initTheme() {
      if (
        window.location.hash === "#/homeaddress/index" ||
        window.location.hash === "#/download/index" ||
        window.location.hash === "#/zfbTip"
      ) {
        this.themeLoading = true;
        return;
      }
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      const serverTheme = await theme.fetchTheme();
      this.$toast.clear();
      if (serverTheme) {
        this.themeLoading = true;
        theme.setTheme(serverTheme);
      }
    },
  },
};
</script>

<style lang="less" scoped>
#app {
  background-color: #ffffff;
}
</style>
